import { cn } from "@/utils/css";

export const RadioCircle = ({ selected, className = "" }) => (
    <span
        className={cn(
            "flex items-center justify-center w-4 h-4 rounded-full shrink-0",
            selected ? "bg-cm-p-on-container-green" : "border-2 border-cm-p-on-container-green",
            className,
        )}
    >
        {selected && <span className="w-1.5 h-1.5 rounded-full bg-cm-p-surface" />}
    </span>
);
